import styles from './PreviewPraedikner.module.css'

// react
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// icons
import { FaArrowRight } from "react-icons/fa";
import { BsSpotify } from "react-icons/bs";
import {FaRegPlayCircle} from "react-icons/fa"

// components
import AudioPlayer from '../../../Components/Post/AudioPlayer';
import FadeInSection from '../../components/FadeInSection';

const PreviewPraedikner = (props) => {

  const {content} = props

  const [episode, setEpisode] = useState({});
  const [playEpsiode, setPlayEpisode] = useState(false);

  const reconstructEpisode = (data) => {
      //preps the data     
      // The title should be in the form of "Title#Scripture XX,XX#Preacher".
      const splitted = data.item.title.split('#');
      let title = '';
      if(splitted[0]!== undefined){
          title = splitted[0];
      }
      let scripture = '';
      if(splitted[1]!== undefined){
        const splittedScripture = splitted[1].split(' ');
        scripture = splittedScripture[2];
      }
      let preacher = '';
      if(splitted[2]!== undefined){
          preacher = splitted[1];
      }
      
      const newData = { title: title, scripture: scripture, preacher: preacher, guid: data.item.guid, isoDate: data.item.isoDate, duration: data.item.itunes.duration, discription: data.item.content, url: data.item.enclosure.url, image: data.item.itunes.image};
        
    setEpisode(newData);
  };

    const handleClick = () => {
      setPlayEpisode(!playEpsiode);
  }

  useEffect(() => {
    async function getFirstEpisodes() {
      
      const API_URL = process.env.NODE_ENV === "development" ? "http://localhost:3000/" : "https://api.hillerodfrimenighed.dk/";
    
      const response = await fetch(`${API_URL}rss`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
    
      if (response.ok) {
        const data = await response.json();
        if (data.length > 0){
          reconstructEpisode(data[0]);
          
        } else {
          setEpisode({});
        }
        
      } else {
        console.log("Error:", response.status);
      }
    }
    getFirstEpisodes();
  }, [])


return(
    <div className={styles.section} >
      <FadeInSection>
      <h1>{content.header}</h1>
      <div className={styles.wrapper}>
        <div className={styles.preViewBox} >
          <div className={styles.preVeiwImage} style={{backgroundImage: `linear-gradient(to bottom, rgba(245, 246, 252, 0.52), rgb(235, 211, 204, 0.60)), url(${content.imageUrl})`}} onClick={handleClick} >
            <h3 className={styles.preacher}>{episode.preacher}</h3>
            <h2 className={styles.title}>{episode.title}</h2>
              {!playEpsiode && <FaRegPlayCircle className={styles.player}/>}
          </div>
          {/* conditionally render the audioPlayer such that the episode has time to be fetched*/}
          {Object.keys(episode).length > 0 && playEpsiode && <AudioPlayer episode={episode} version={"v2"}></AudioPlayer>} 
        </div>
        <a className={styles.spotify} href='https://open.spotify.com/show/0ZjwjEYqNU44VumIpoyEHG?si=f8789070cd554252'><BsSpotify></BsSpotify> Spotify</a>
        <p className={styles.text} dangerouslySetInnerHTML={{ __html: content.text }}/>
        <Link className={styles.button} to="/Praedikener"><button>Lyt til flere prædikener <FaArrowRight className='Arrow'/></button></Link> 
      </div>
      </FadeInSection>
    </div>
);
}

export default PreviewPraedikner